export default "__VITE_ASSET__gLcqblid__"